import { keymap } from 'prosemirror-keymap';
import { EditorView } from 'prosemirror-view';

import { EditorButton, ProsemirrorCommand, RtPMPlugin } from '../../../editor/types';
import { MarkService } from '../../../helpers/mark-base';
import { DEFAULT_KEYMAP_INPUTRULE_PRIORITY } from '../../../helpers/utils';
import { StrikethroughSchema } from './strikethrough-mark';

export class StrikethroughService<S extends StrikethroughSchema> extends MarkService<S> {}

export class StrikethroughPlugin implements RtPMPlugin {
  public buttons = {
    toggleStrikethrough: <EditorButton>{
      icon: 'format-strikethrough',
      isActive: (...args) => this.strikethroughService.isActive(...args),
      run: (state, dispatch) => {
        this.strikethroughService.toggle(state, dispatch);
      },
    },
  };

  private editorView: EditorView<StrikethroughSchema>;
  private strikethroughService: StrikethroughService<StrikethroughSchema>;

  public beforeEditorInit(schema: StrikethroughSchema) {
    this.strikethroughService = new StrikethroughService(schema.marks.strikethrough);
  }

  public afterEditorInit(editorView: EditorView<StrikethroughSchema>) {
    this.editorView = editorView;
  }

  public getNativeEditorPlugins() {
    return [{ priority: DEFAULT_KEYMAP_INPUTRULE_PRIORITY, plugin: keymap(this.getKeyBindings()) }];
  }

  private getKeyBindings() {
    const toggle: ProsemirrorCommand = (...args) => this.strikethroughService.toggle(...args);
    return {
      'Mod-Shift-x': toggle,
      'Alt-Shift-5': toggle,
    };
  }
}
